import styled from 'styled-components';
import { UIData, useUIStore } from '../../../hooks/stores/uiStore';
import { IconButton } from '../../common/IconButton';
import { ContainerComboInput } from '../../common/specificPropInputs/styleProps/containerComboInput/ContainerComboInput';
import { EffectComboInput } from '../../common/specificPropInputs/styleProps/effectComboInput/EffectComboInput';
import { TextComboInput } from '../../common/specificPropInputs/styleProps/textComboInput/TextComboInput';
import { useScene } from '../../../context/sceneContext';

export const StylePropsPanel = () => {
  const scene = useScene();
  const [UIData, setUIData] = useUIStore<UIData>();
  const inputs = scene.getSelectedElementsPropInputs();

  const areSelectedElementsOnlyButtonsOrLinks = UIData.selectedElementIDs.every((element) => {
    const { type } = scene.getElementData(element, { type: undefined }, '');
    return type === 'button' || type === 'link';
  });

  const areSelectedElementsInputs = UIData.selectedElementIDs.every((element) => {
    const { type } = scene.getElementData(element, { type: undefined }, '');
    return type === 'targetVariableInput';
  });

  return (
    <>
      <PseudoclassButtons>
        <IconButton
          iconClassName="icon-properties"
          label="Default"
          isActive={UIData.pseudoclass === undefined}
          onClick={() => setUIData({ pseudoclass: undefined })}
        />
        <IconButton
          iconClassName="icon-hover"
          label="Hovered"
          isActive={UIData.pseudoclass === 'hover'}
          onClick={() => setUIData({ pseudoclass: 'hover' })}
        />
        {areSelectedElementsOnlyButtonsOrLinks && (
          <IconButton
            iconClassName="icon-pressed"
            label="Pressed"
            isActive={UIData.pseudoclass === 'active'}
            onClick={() => setUIData({ pseudoclass: 'active' })}
          />
        )}

        {areSelectedElementsInputs && <IconButton
          iconClassName="icon-focus"
          label="Focused"
          isActive={UIData.pseudoclass === 'focus'}
          onClick={() => setUIData({ pseudoclass: 'focus' })}
        />}
      </PseudoclassButtons>

      <ComboInputContainer>
        {inputs.includes('textComboInput') && <TextComboInput />}
        {inputs.includes('containerComboInput') && <ContainerComboInput />}
        {inputs.includes('effectComboInput') && <EffectComboInput />}
      </ComboInputContainer>
    </>
  );
};

const PseudoclassButtons = styled.div`
  width: 100%;
  height: 35px;
  border-bottom: 1px solid var(--neutral-3);

  display: flex;
  gap: 2px;

  margin-bottom: 20px;
`;

const ComboInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: calc(var(--padding-1) / 2);
`;
